import type { FC } from 'react';
import React from 'react';
import moment from 'moment';
import { getTextThemeProvider } from 'venn-ui-kit';

export interface CopyrightProps {
  className?: string;
  lineBreak?: boolean;
  year?: number | string;
}

const Copyright: FC<React.PropsWithChildren<CopyrightProps>> = ({
  className = '',
  lineBreak = false,
  year = moment.utc().format('YYYY'),
}) => (
  <div className={className}>
    {`© ${year} ${getTextThemeProvider().copyrightEntity}. All rights reserved. `}
    {getTextThemeProvider().trademarkText && lineBreak && <br />}
    {getTextThemeProvider().trademarkText}
  </div>
);

export default Copyright;
